// import React, { Fragment, useEffect, useState } from 'react';
// import { Link, useHistory } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import { useLocation } from 'react-router';
// import { url, postPerPage, hrdurl, giaurl } from '../../../../config';
// import { FormattedMessage, useIntl } from 'react-intl';
// import { IMAGES } from '../../../../constants';
// import { myProductAction, myProductFilterByAscending, myProductFilter, getUrlToDownloadDocument, myProductSelectAction, myProductActiveAll, myProductDeactiveAll, myProductShowSold, clearMessage, myProductDeleteAll, GetProductCount, myProductStatusAction, myProductsSideFilter, getUrlToDownloadForUserAction } from '../../../../actions/productActions';
// import { AdvertisementFreePurchaseAction, checkAdvertisementPlan } from '../../../../actions/Advertisement';
// import { getLastURL, handleSortBy, pColmDisplay, GenerateCertificatePdf, handleSortByAction, capitalizeFirstLetterWithOnlyLetter, numberWithCommas, totalPriceDisplay, totalPriceDisplayforDiscount, totalCarat, translationMap, Slugs } from '../../../../helper';
// import Loader from '../../../layout/Loader';
// // import { diamondsJson, selectActionJson } from '../../../../utils/json';
// import { diamondsJson, selectActionJson, selectActionJsonDiamonds } from '../../../../utils/json';
// import $ from 'jquery';
// import { getCategory } from '../../../../actions/categoryAction';
// import { useAlert } from 'react-alert';
// import ReactPaginate from "react-paginate";
// import Popup from '../popup';
// import PopupConfirm from '../../../layout/PopupConfirm';
// import MyProductsSideFilter from '../../../products/whiteDimonds/MyProductsSideFilter';

// const WhiteDimonds = (props) => {

//     const dispatch = useDispatch();
//     const location = useLocation();
//     const history = useHistory();
//     const alert = useAlert();
//     const category_slug = getLastURL(location);
//     const { myproduct, loading } = useSelector(state => state.myproduct);
//     const [activeFilters, setActiveFilters] = useState();

//     const productFilter = useSelector(state => state.DownloadPdfWithFilterState)
//     const { myproductselectaction } = useSelector(state => state.myproductselectaction);
//     const { myproductstatusaction } = useSelector(state => state.myproductstatusaction);
//     const { myproductactiveall } = useSelector(state => state.myproductactiveall);
//     const free_ad_purchase_data = useSelector(state => state.AdvertisementFreePurchaseState);
//     const getUrlToDownloadForUser = useSelector(state => state.getUrlToDownloadForUserState);

//     const [filterdisplayname, setFilterDisplayName] = useState(<FormattedMessage id="Select Sort Option" />);
//     const [actionname, setActionName] = useState(<FormattedMessage id="Actions" />)
//     const [search, setSearch] = useState();
//     const [currentPage, setCurrentPage] = useState(0);
//     const [postsPerPage, setPostPerPage] = useState(postPerPage);

//     const [selectAllStock, setSelectAllStock] = useState(new Array(myproduct && myproduct.products && myproduct.products.data && myproduct.products.data.length).fill(false));
//     const [selectedAction, setSeletedAction] = useState();
//     const [selectedId, setSelectedId] = useState([]);
//     const selectedArray = [];
//     const [checkHead, setCheckHead] = useState(false);
//     const [sold, setSold] = useState(false);
//     const { checkPlan } = useSelector(state => state.checkPlanReducer);
//     const [prod_id, setCurrentId] = useState(0);
//     const [showFilters, setShowFilters] = useState(false);
//     const [sideFilters, setSideFilters] = useState();

//     const pathname = getLastURL(location);
//     const { attributes } = useSelector((state) => state.attributes);

//     useEffect(() => {
//         dispatch(myProductAction(category_slug, 1));
//     }, [dispatch])

//     const handlePageChange = ({ selected }) => {
//         props.updateResetPageHandler(selected)

//         if (sideFilters) {
//             dispatch(myProductsSideFilter(category_slug, sideFilters, (selected + 1)));
//         } else {
//             dispatch(myProductAction(category_slug, (selected + 1)));
//         }
//     }

//     const pageCount = Math.ceil((myproduct && myproduct.products && myproduct.products.total) / postsPerPage);

//     const handleAcendingFilter = (value, type, displayname) => {
//         setFilterDisplayName(displayname)
//         $('.sort_by_list').css({
//             display: "none"
//         })
//         props.tabChangeHandler(1)
//         dispatch(myProductFilterByAscending(category_slug, value, type))
//     }

//     const handleSearch = (e) => {
//         setSearch(e.target.value);
//     }

//     const handleSearchFilter = (e) => {
//         if (e.key === 'Enter') {
//             dispatch(myProductFilter(category_slug, { search: search }));
//         }
//     }
//     const handleSearchIconClick = () => {
//         dispatch(myProductFilter(category_slug, { search: search }));
//     };

//     useEffect(() => {
//         if (getUrlToDownloadForUser?.documentDetail?.pdf_url) {
//             const link = document.createElement('a');
//             // link.href = products?.pdf_url;
//             window.open(getUrlToDownloadForUser?.documentDetail?.pdf_url)
//             link.download = 'diamonds.pdf';
//             document.body.appendChild(link);
//             link.click();
//             dispatch({
//                 type: "DOWNLOAD_DIAMOND_EXCEL_FOR_USER_FAIL",
//                 payload: null
//             })
//         }
//     }, [getUrlToDownloadForUser])

//     const handleStockManagement = (id, position) => {
//         const updatedSelectAllStock = selectAllStock && selectAllStock.map((item, index) => {
//             if (index === position) {
//                 return !item;
//             } else {
//                 return item;
//             }
//         });
//         setSelectAllStock(updatedSelectAllStock);

//         if (!selectedId.includes(id)) {
//             setSelectedId([...selectedId, id]);
//         } else {
//             selectedId.splice(selectedId.indexOf(id), 1);
//         }
//     }

//     const handlecheckPlan = (id) => {
//         // dispatch(checkAdvertisementPlan(id));
//         dispatch(AdvertisementFreePurchaseAction(id));
//         setCurrentId(id);
//     }

//     const selectAll = (selectAllStock) => {
//         if (selectAllStock.every(e => e === false)) {
//             setSelectAllStock(new Array(myproduct && myproduct.products && myproduct.products.data && myproduct.products.data.length).fill(true));

//             myproduct && myproduct.products && myproduct.products.data && myproduct.products.data.map((data, key) => {
//                 selectedArray.push(data.id);
//             })
//             setCheckHead(true);
//             setSelectedId(selectedArray);

//         } else {
//             setSelectAllStock(new Array(myproduct && myproduct.products && myproduct.products.data && myproduct.products.data.length).fill(false));
//             selectedArray.pop();
//             setSelectedId([]);
//             setCheckHead(false);
//         }
//     }

//     const handleSelectAction = (event, value) => {

//         $('.sort_by_action').css({
//             display: "none"
//         })

//         if (value == 'excel_all') {
//             dispatch(getUrlToDownloadForUserAction(category_slug, [], true, "excel_all", productFilter?.data?.filter));
//         }

//         else {
//             if (selectedId.every(e => e === false) || selectedId === null) {
//                 alert.error('Please select stock');
//                 setSeletedAction("");
//                 return;
//             }
//             setSeletedAction(value);
//             dispatch(myProductSelectAction(selectedId, value));
//             dispatch(GetProductCount());
//             setSold(false);
//         }
//     }

//     const handleActiveAll = async () => {
//         await dispatch(myProductActiveAll());
//         dispatch(myProductAction(category_slug));
//         dispatch(GetProductCount());
//         dispatch(getCategory());

//     }

//     const handleInActiveAll = async () => {
//         await dispatch(myProductDeactiveAll(category_slug));
//         dispatch(myProductAction(category_slug));
//         dispatch(GetProductCount());
//         dispatch(getCategory());

//     }

//     const handleResForm = async (status) => {
//         if (status) {
//             await dispatch(myProductDeleteAll(category_slug));
//             await dispatch(myProductAction(category_slug));
//             await dispatch(GetProductCount());
//             await dispatch(getCategory());
//         }
//         $("#dismiss-modal").trigger('click');

//     }

//     const handleDeleteAllClick = (event) => {
//         $("#popup-click-confirm").trigger('click');
//     }

//     // useEffect(() => {
//     //     if (checkPlan) {
//     //         if (checkPlan?.data) {
//     //             history.push(url + `/advertise-plan-details/${prod_id}`);
//     //         } else {
//     //             alert.error(checkPlan['message']);
//     //         }
//     //         dispatch(checkAdvertisementPlan("RESET"));
//     //     }
//     //     //setCurrentId([]);
//     // }, [checkPlan])

//     useEffect(() => {
//         if (free_ad_purchase_data?.data) {
//             if (free_ad_purchase_data?.data?.data) {
//                 // history.push(url + `/advertise-plan-details/${prod_id}`);
//                 alert.success("Item Advertised")
//             } else {
//                 alert.error(free_ad_purchase_data?.data['message']);
//             }
//             dispatch(AdvertisementFreePurchaseAction("RESET"));
//         }
//         //setCurrentId([]);
//     }, [free_ad_purchase_data?.data])

//     useEffect(() => {
//         if (myproductselectaction) {
//             alert.success(myproductselectaction);
//             dispatch(clearMessage());
//             setSelectAllStock([]);
//             setSelectedId([]);

//             setCheckHead(false);
//             setSeletedAction("");
//             dispatch(myProductAction(category_slug));
//             dispatch(getCategory());
//             return
//         }
//         if (myproductactiveall) {
//             alert.success(<div className="react-alert-change-css">{myproductactiveall}</div>);
//             dispatch(clearMessage());
//             return
//         }

//         if (myproductstatusaction) {
//             alert.success(<div className="react-alert-change-css">{myproductstatusaction}</div>);
//             dispatch(clearMessage());
//             return
//         }
//     }, [myproductselectaction, myproductactiveall, myproductstatusaction])

//     const handleSoldProducts = (event) => {
//         setSold(event.target.checked);
//         dispatch(myProductShowSold(category_slug, event.target.checked));
//     }

//     const handleSingleActivate = async (action, id) => {
//         let ids = [];
//         ids.push(id)
//         await dispatch(myProductSelectAction(ids, action));
//         await dispatch(myProductAction(category_slug));
//         dispatch(GetProductCount());
//         dispatch(getCategory());
//     }

//     const handleStatusChange = async (action, id) => {
//         await dispatch(myProductStatusAction(id, action));
//         await dispatch(myProductAction(category_slug));
//         dispatch(GetProductCount());
//         dispatch(getCategory());
//     }

//     const handleDetails = (id) => {
//         history.push(url + `/details/diamonds/${id}`);
//     }

//     const handleFilter = (keyToRemove) => {
//         const updatedFilter = Object.entries(activeFilters).filter(([key]) => key !== keyToRemove).reduce((acc, [key, value]) => {
//           if(key === 'carat' || key === 'no_BGM') {
//                         acc[key] = value;
//                         return acc;
//                      }
//             acc[key] = value.map(item => item.attribute_id);
//             return acc;
//         }, {})

//         // setActiveFilters(updatedFilter);
//         dispatch(myProductsSideFilter(pathname, updatedFilter));
//     };

//     useEffect(() => {
//         if (!loading) {
//             if (myproduct?.filter && !Array.isArray(myproduct?.filter)) {
//                 setActiveFilters(myproduct?.filter);
//             } else {
//                 setActiveFilters([])
//             }
//         }
//     }, [myproduct]);

//     const comaSeperatedFilter = (arr) => {
//         let val = ""
//         if (Array.isArray(arr)) {
//             for (let i = 0; i < arr.length; i++) {
//                 val += arr[i].display_name + (i === arr.length - 1 ? '' : ', ');
//             }
//         } else {
//             return arr;
//         }
//         return val;
//     }

//     return (
//         <Fragment>
//             {/* {(loading || free_ad_purchase_data?.loading || getUrlToDownloadForUser?.loading) && <Loader />} */}
//             <Fragment>
//                 <div className="col-xl-10 col-lg-9 col-md-9 col-sm-8">
//                     {(loading || free_ad_purchase_data?.loading || getUrlToDownloadForUser?.loading) ? <div className="loader-line"></div> : ""}
//                     <div className="titles mt-4 mb-3 pb-3">
//                         <div className="row">
//                             <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
//                                 <h2 className="m-0"><FormattedMessage id="category.diamonds" />
//                                     <span className="pro_nub w-auto px-2"> {myproduct && myproduct?.products && myproduct?.products?.total} </span>
//                                 </h2>
//                             </div>

//                             <div className="col-xl-9 col-lg-8 col-sm-6 col-md-6 hides ">
//                                 {/* <div className=" form-group ml-3 form-inline">
//                                 <button className="btn-black active-all" data-toggle="modal" data-target="#popup"><span><span className="fa fa-check"></span><span>{` `}</span>Pop up form</span></button>
//                             </div> */}
//                                 <div className=" form-group ml-3 form-inline">
//                                     <Link to={url + `/advertisement/diamonds`} >
//                                         <button type="button" className="btn-black active-all">
//                                             <span>
//                                                 <span className="fas fa-ad"></span>
//                                                 <span>{` `}</span>
//                                                 <FormattedMessage id="Advertisement" defaultMessage="Advertisement Histroy" />
//                                             </span>
//                                         </button>
//                                     </Link>
//                                 </div>
//                                 <div className=" form-group ml-3 form-inline">
//                                     <button type="button" className="btn-black active-all" onClick={handleActiveAll}><span><span className="fa fa-check"></span><span>{` `}</span> <FormattedMessage id="UpdateMyListings" defaultMessage="Update My Listingsss" /></span></button>
//                                 </div>
//                                 <div className=" form-group ml-3 form-inline">
//                                     <button type="button" className="btn-black active-all" onClick={handleInActiveAll}><span><span className="fa fa-close"></span><span>{` `}</span> <FormattedMessage id="UnlistAllItems" defaultMessage="Unlist All Items" /></span></button>
//                                 </div>
//                                 <div className=" form-group ml-3 form-inline">
//                                     <button type="button" className="btn-black active-all" onClick={handleDeleteAllClick}><span><span className="fa fa-trash"></span><span>{` `}</span> <FormattedMessage id="DeleteAllItems" defaultMessage="Delete All Items" /></span></button>
//                                 </div>
//                                 <div className="form-group mb-0 form-inline">
//                                     <Link to={url + '/add-product'}>
//                                         <button type="button" className="btn-black">
//                                             <span className="icon-add_1"></span>
//                                             <span>{` `}</span>
//                                             <FormattedMessage
//                                                 id="addsingleproduct.add-new-product"
//                                                 defaultMessage="Add New Items"
//                                             />
//                                         </button>
//                                     </Link>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     <div className={'side-filter-overlay' + (showFilters ? " show" : "")} onClick={() => setShowFilters(false)}></div>
//                     <div className={'side-filter' + (showFilters ? " open" : "")}>
//                         <div className='side-filter-inner '>
//                             <button
//                                 className='close-filter'
//                                 id="close-side-filter"
//                                 onClick={() => setShowFilters(false)}
//                             >&times;</button>
//                             <div className='row'>
//                                 <MyProductsSideFilter setShowFilters={setShowFilters} setSideFilters={setSideFilters} resetPage={props.updateResetPageHandler} />
//                             </div>
//                         </div>
//                     </div>
//                     <div className="titles mt-4  border-0">
//                         <div className="filter_search_right">
//                             <div className="search_cat_top border-0">
//                                 <div className="row">

//                                     <div className="col-lg-12 col-md-12 col-sm-12 d-flex flex-wrap justify-content-md-end">
//                                         <div className="form-group mb-0 mr-3 form-inline ">
//                                             <input type="checkbox" id="sold" checked={sold} onChange={handleSoldProducts} />
//                                             <label htmlFor="sold" className="mt-2"><FormattedMessage id="Show sold products" /></label>
//                                         </div>
//                                         <div className="form-group pb-0 sort_by_box">
//                                             <p className="sort_b_h text-right side-dropdown" onClick={handleSortBy}>
//                                                 <b className="mr-2"><FormattedMessage id="Sort_By" />:</b>
//                                                 {filterdisplayname} <span className="icon-chevron_down">
//                                                 </span>
//                                             </p>
//                                             <div className="sort_by_list">
//                                                 <ul>
//                                                     {
//                                                         diamondsJson && diamondsJson.map((data, key) => {
//                                                             return (
//                                                                 <li className="activess" onClick={() => handleAcendingFilter(data.value, data.type, data.display_name)}>{data.display_name}</li>
//                                                             )
//                                                         })
//                                                     }
//                                                 </ul>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     <div className="row filter_search_right align-items-center justify-content-between" >
//                         <div className="col-lg-6 col-md-6">
//                             <div className="d-flex">
//                                 {/* <button
//                                     type="button"
//                                     className="btn-black active-all mb-3 mt-2"
//                                     onClick={() => setShowFilters(true)}>
//                                     <span>
//                                         <span className="fas fa-filter"></span>
//                                         <span>{' '}</span>
//                                         <FormattedMessage
//                                             id="addsingleproduct.all-filters"
//                                             defaultMessage="All Filters"
//                                         />
//                                     </span>
//                                 </button> */}
//                                 <div className="filter_search_right">
//                                     <div className="search_cat_top border-0">
//                                         <div className="form-group pb-0 sort_by_box">
//                                             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                                                 <button className='all-filters-btn'onClick={() => setShowFilters(true)} type='button'><img src={IMAGES.filterIcon} alt="filter-icon" />
//                                                     <FormattedMessage
//                                                         id="addsingleproduct.all-filters"
//                                                         defaultMessage="All Filters"
//                                                     />
//                                                 </button>
//                                                 {/* <p className="sort_b_h text-right" onClick={() => setShowFilters(true)}>
//                                                     <FormattedMessage
//                                                         id="addsingleproduct.all-filters"
//                                                         defaultMessage="All Filters"
//                                                     />
//                                                     <span className="icon-chevron_down"></span>
//                                                 </p> */}
//                                                 <p className="sort_b_h text-right ms-3" onClick={handleSortByAction}>
//                                                     {/* <b className="mr-2">
//                                                         <FormattedMessage id="Select Actions" />:</b> */}
//                                                     {actionname}
//                                                     <span className="icon-chevron_down"></span>
//                                                 </p>
//                                             </div>
//                                             <div className="sort_by_action" style={{ width: "max-content" }}>
//                                                 <ul>

//                                                     {
//                                                         selectActionJsonDiamonds?.length && selectActionJsonDiamonds?.map((data, key) => {
//                                                             return (
//                                                                 <li key={key}
//                                                                     className="activess"
//                                                                     onClick={(e) => handleSelectAction(e, data.value)}>
//                                                                     {data.display_name}
//                                                                 </li>
//                                                             )
//                                                         })
//                                                     }
//                                                 </ul>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>

//                         <div className=" col-lg-4 col-md-4 col-sm-4">
//                             <div className="seach_filter position-relative">
//                                 <input
//                                     type="text"
//                                     value={search}
//                                     onKeyPress={(e) => handleSearchFilter(e)}
//                                     onChange={handleSearch}
//                                     className="form-control"
//                                     placeholder={useIntl().formatMessage({ id: 'SearchByStock' })}
//                                 />
//                                 <span className="icon-search_1  input_icon position-absolute" onClick={handleSearchIconClick} style={{ cursor: 'pointer' }}></span>
//                             </div>
//                         </div>
//                     </div>

//                     <div className='d-flex flex-wrap gap-3'>
//                         {
//                             activeFilters ?
//                                 Object.entries(activeFilters).map(([key, value]) => {
//                                     if (key == "carat") {
//                                       return  (
//                                     <div className='filter_search_right'>
//                                             <div className='search_cat_top border-0'>
//                                                 <div className="s_c" key={key}>
//                                                     <p>
//                                                         <span className='first-letter'>
//                                                             <b>Carat:</b> {value?.from} - {value?.to}
//                                                         </span>
//                                                         <button
//                                                             className='text-black border-0 p-0 bg-none ml-3'
//                                                             style={{ outline: 'none' }}
//                                                             onClick={() => handleFilter(key)}
//                                                         >
//                                                             <i className='icon-close_1 ml-0'></i>
//                                                         </button>
//                                                     </p>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                       )
//                                     }
//                                     let translatedKey = localStorage.getItem('lang') === 'tr' ? translationMap[key] : key;

//                                     return (
//                                         <div className='filter_search_right'>
//                                             <div className='search_cat_top border-0'>
//                                                 <div className="s_c" key={key}>
//                                                     <p>
//                                                         <span className='first-letter'>
//                                                             <b>{translatedKey}:</b> {comaSeperatedFilter(value)}
//                                                         </span>
//                                                         <button
//                                                             className='text-black border-0 p-0 bg-none ml-3'
//                                                             style={{ outline: 'none' }}
//                                                             onClick={() => handleFilter(key)}
//                                                         >
//                                                             <i className='icon-close_1 ml-0'></i>
//                                                         </button>
//                                                     </p>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     )
//                                 })
//                                 : ""
//                         }
//                     </div>
//                     <div className="tbles mb-5">
//                         <table width="100%">
//                             <tr>
//                                 <th>
//                                     <div className="form-group mb-0 mini checks inss">
//                                         <input className="" type="checkbox" id="checkall" checked={checkHead} onChange={() => selectAll(selectAllStock)} />
//                                         <label htmlFor="checkall"></label>
//                                     </div>
//                                 </th>
//                                 <th><FormattedMessage id="addsingleproduct.stockno" /></th>
//                                 <th><FormattedMessage id="Shape" defaultMessage="Shape" /></th>
//                                 <th><FormattedMessage id="addsingleproduct.carat" defaultMessage="Carat" /></th>
//                                 {
//                                     myproduct && myproduct?.is_fancy == 1 ?
//                                         <>
//                                             <th><FormattedMessage id="Intensity" defaultMessage="Intensity" /></th>
//                                             <th><FormattedMessage id="Overtone" defaultMessage="Overtone" /></th>
//                                         </>
//                                         : ""
//                                 }
//                                 <th><FormattedMessage id="addsingleproduct.color" defaultMessage="Color" /></th>
//                                 <th><FormattedMessage id="addsingleproduct.clarity" defaultMessage="Clarity" /></th>
//                                 <th><FormattedMessage id="addsingleproduct.cut" defaultMessage="Cut" /></th>
//                                 <th><FormattedMessage id="addsingleproduct.pol" defaultMessage="Pol" /></th>
//                                 <th><FormattedMessage id="addsingleproduct.sym" defaultMessage="Sym" /></th>
//                                 <th><FormattedMessage id="addsingleproduct.Fluor" defaultMessage="Fluor" /></th>
//                                 <th><FormattedMessage id="Milky" defaultMessage="Milky" /></th>
//                                 <th><FormattedMessage id="Bgm" defaultMessage="BGM" /></th>
//                                 <th><FormattedMessage id="Cert" defaultMessage="Cert" /></th>
//                                 <th>Price/ct</th>
//                                 <th><FormattedMessage id="Disc" defaultMessage="Disc" /></th>
//                                 <th><FormattedMessage id="addsingleproduct.price" /></th>
//                                 <th><FormattedMessage id="Status" defaultMessage="Status" /></th>
//                                 <th><FormattedMessage id="Actions" /></th>
//                             </tr>

//                             {
//                                 myproduct && myproduct?.products && myproduct?.products?.data?.length > 0 ?
//                                     myproduct && myproduct?.products && myproduct?.products?.data && myproduct?.products?.data?.map((data, key) => {
//                                         return (
//                                             <tr>
//                                                 <td>
//                                                     <div className="form-group mb-0 mini inss">
//                                                         <input
//                                                             type="checkbox"
//                                                             id={data.id}
//                                                             name="check"
//                                                             checked={selectAllStock[key]}
//                                                             onChange={() => handleStockManagement(data.id, key)}
//                                                         />
//                                                         <label htmlFor={data.id}></label>
//                                                     </div>
//                                                 </td>
//                                                 <td onClick={(e) => handleDetails(data.id)}>{data && data.stock_number}</td>
//                                                 <td onClick={(e) => handleDetails(data.id)}>{pColmDisplay(data, 'a_shape')}</td>
//                                                 <td onClick={(e) => handleDetails(data.id)}>{data && data.carat && totalCarat(data)}</td>
//                                                 {
//                                                     myproduct && myproduct?.is_fancy == 1 ?
//                                                         <>
//                                                             <td onClick={(e) => handleDetails(data.id)}>{pColmDisplay(data, 'a_fancy_intensity')}</td>
//                                                             <td onClick={(e) => handleDetails(data.id)}>{pColmDisplay(data, 'a_fancy_overtone')}</td>
//                                                             <td onClick={(e) => handleDetails(data.id)}>{pColmDisplay(data, 'a_fancy_color')}</td>
//                                                         </>
//                                                         :
//                                                         <td onClick={(e) => handleDetails(data.id)}>{pColmDisplay(data, 'a_color')}</td>
//                                                 }
//                                                 <td onClick={(e) => handleDetails(data.id)}>{pColmDisplay(data, 'a_clarity')}</td>
//                                                 <td onClick={(e) => handleDetails(data.id)}>{data && data.a_cut && capitalizeFirstLetterWithOnlyLetter(pColmDisplay(data, 'a_cut'))}</td>
//                                                 <td onClick={(e) => handleDetails(data.id)}>{data && data.a_polish && capitalizeFirstLetterWithOnlyLetter(pColmDisplay(data, 'a_polish'))}</td>
//                                                 <td onClick={(e) => handleDetails(data.id)}>{data && data.a_symmetry && capitalizeFirstLetterWithOnlyLetter(pColmDisplay(data, 'a_symmetry'))}</td>
//                                                 <td onClick={(e) => handleDetails(data.id)}>{data && data.a_fluorescence && capitalizeFirstLetterWithOnlyLetter(pColmDisplay(data, 'a_fluorescence'))}</td>

//                                                 <td onClick={(e) => handleDetails(data.id)}>{pColmDisplay(data, 'milky')}</td>
//                                                 <td onClick={(e) => handleDetails(data.id)}>{data && data['bgm'] == "0" ? 'Yes' : "No"} </td>

//                                                 {/* {data && data.certificate_url ?
//                                                     <td><a href={GenerateCertificatePdf(data.certificate_url)} target={GenerateCertificatePdf(data.certificate_url)}>{pColmDisplay(data, 'a_certificate')}</a></td>
//                                                     :
//                                                     <td>{pColmDisplay(data, 'a_certificate')}</td>
//                                                 } */}
//                                                 {
//                                                     (() => {
//                                                         if (data && data.certificate_url) {
//                                                             return <td><a href={GenerateCertificatePdf(data.certificate_url)} target={GenerateCertificatePdf(data.certificate_url)}>{pColmDisplay(data, 'a_certificate')}</a></td>
//                                                         }
//                                                         else if (pColmDisplay(data, 'a_certificate') == "HRD") {
//                                                             return <td><a href={hrdurl + data.certificate_number} target="_blank">{pColmDisplay(data, 'a_certificate')}</a></td>
//                                                         } else if (data.certificate == "25" && pColmDisplay(data, 'a_certificate') == "GIA") {
//                                                             return <td><a href={giaurl + data.certificate_number} target="_blank">{pColmDisplay(data, 'a_certificate')}</a></td>
//                                                         } else {
//                                                             return <td>{pColmDisplay(data, 'a_certificate')}</td>
//                                                         }
//                                                     })()
//                                                 }

//                                                 <td>${data && data.price && numberWithCommas(parseFloat(data.price).toFixed(2))}</td>
//                                                 <td onClick={(e) => handleDetails(data.id)}>
//                                                     {data && data?.discount && totalPriceDisplayforDiscount(data)} </td>
//                                                 <td onClick={(e) => handleDetails(data.id)}>{
//                                                     totalPriceDisplay(data)}</td>

//                                                 <td className="text-right Active-st-td">
//                                                     <span
//                                                         style={{ color: data && data?.availability_status?.attribute_id === 2316 ? 'green' : 'red', fontWeight: '600' }}>
//                                                         {pColmDisplay(data, 'availability_status')}
//                                                     </span>
//                                                     <div className="more">
//                                                         <span><img src={IMAGES.THREE_DOT} alt="" /></span>
//                                                         <ul>
//                                                             {
//                                                                 data && data?.availability_status?.attribute_id === 2316 ?
//                                                                     <li onClick={(e) => handleStatusChange(2320, data.id)}><h6><FormattedMessage id="On_Memo" /></h6></li>
//                                                                     :
//                                                                     <li onClick={(e) => handleStatusChange(2316, data.id)}><h6><FormattedMessage id="Available" /></h6></li>
//                                                             }
//                                                         </ul>
//                                                     </div>
//                                                 </td>
//                                                 <td className="text-right Active-st-td">
//                                                     <span style={{ color: data.status === 1 ? 'green' : 'red', fontWeight: '600' }}>
//                                                         {data.status === 1 ? <FormattedMessage id="Listed" /> : <FormattedMessage id="Unlisted" />}
//                                                     </span>
//                                                     <div className="more">
//                                                         <span><img src={IMAGES.THREE_DOT} alt="" /></span>
//                                                         <ul>
//                                                             <li>
//                                                                 <h6 onClick={(e) => handlecheckPlan(data.id)}>
//                                                                     <FormattedMessage id="Advertise This Item" />
//                                                                 </h6>
//                                                             </li>
//                                                             <li>
//                                                                 <Link
//                                                                     // to={{ pathname: url + '/edit-full-product/' + data.id }}
//                                                                     to={{ pathname: `${url}/edit-full-product/${Slugs?.Diamonds}/${data.id}` }}
//                                                                     style={{ paddingTop: '0px' }}>
//                                                                     <h6><FormattedMessage id="Edit Product" /></h6>
//                                                                 </Link>
//                                                             </li>
//                                                             <li>
//                                                                 <Link
//                                                                     to={{
//                                                                         pathname: url + '/edit-product/' + data?.id,
//                                                                         // query: {
//                                                                         //     'discount': data.discount,
//                                                                         //     'price': data.price,
//                                                                         //     category_slug
//                                                                         // }
//                                                                         search: `?discount=${data?.discount}&price=${data?.price}&category_slug=${category_slug}&is_fancy=${data?.is_fancy}`
//                                                                     }}
//                                                                     style={{ paddingTop: '0px' }}>
//                                                                     <h6><FormattedMessage id="Edit Price" /></h6>
//                                                                 </Link>
//                                                             </li>
//                                                             {
//                                                                 data?.status === 1 ?
//                                                                     <li onClick={(e) => handleSingleActivate('deactivate', data.id)}>
//                                                                         <h6><FormattedMessage id="Unlist Item" /></h6>
//                                                                     </li>
//                                                                     :
//                                                                     <li onClick={(e) => handleSingleActivate('active', data.id)}>
//                                                                         <h6><FormattedMessage id="List Item" /></h6>
//                                                                     </li>
//                                                                 // <img src={IMAGES.EDIT_PNG} className="mr-2" alt="" />
//                                                             }
//                                                             <li onClick={(e) => handleSingleActivate('delete', data.id)}>
//                                                                 <h6><FormattedMessage id="Delete" /></h6>
//                                                             </li>
//                                                         </ul>
//                                                     </div>
//                                                 </td>
//                                             </tr>
//                                         )
//                                     })
//                                     :
//                                     <tr>
//                                         <th colSpan="18">
//                                             <FormattedMessage id="ProductNotFound" defaultMessage="Product not Found" />
//                                         </th>
//                                     </tr>
//                             }

//                         </table>
//                     </div>
//                     {
//                         myproduct?.products?.total > 0 ?
//                             <div className="table_pagination">
//                                 <ReactPaginate
//                                     previousLabel={<i className="icon icon-chevron_gray-left"></i>}
//                                     nextLabel={<i className="icon icon-chevron_black"></i>}
//                                     pageCount={pageCount}
//                                     onPageChange={handlePageChange}
//                                     containerClassName={"paginationBttns"}
//                                     previousLinkClassName={myproduct?.products?.total ? "previousBttn" : ""}
//                                     nextLinkClassName={myproduct?.products?.total ? "nextBttn" : ""}
//                                     disabledClassName={"paginationDisabled"}
//                                     activeClassName={"paginationActive"}
//                                     forcePage={props?.pageReset}
//                                 />
//                             </div>
//                             : ""
//                     }
//                 </div>
//                 <Popup />
//             </Fragment>
//             {
//                 <PopupConfirm
//                     message={useIntl().formatMessage({ id: 'deleteAllProducts' })}
//                     title={useIntl().formatMessage({ id: 'Confirmation' })}
//                     handleResForm={handleResForm}
//                 />
//             }
//         </Fragment>
//     )
// }

// export default WhiteDimonds


import React, { Fragment, useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { url, postPerPage, hrdurl, giaurl } from '../../../../config';
import { FormattedMessage, useIntl } from 'react-intl';
import { IMAGES } from '../../../../constants';
import { myProductAction, myProductFilterByAscending, myProductFilter, getUrlToDownloadDocument, myProductSelectAction, myProductActiveAll, myProductDeactiveAll, myProductShowSold, clearMessage, myProductDeleteAll, GetProductCount,getAllDiamondsProductsFilter, myProductStatusAction, myProductsSideFilter, getUrlToDownloadForUserAction  , getAllMyProductsFilter} from '../../../../actions/productActions';
import { AdvertisementFreePurchaseAction, checkAdvertisementPlan } from '../../../../actions/Advertisement';
import { getLastURL, handleSortBy, pColmDisplay, GenerateCertificatePdf, handleSortByAction, capitalizeFirstLetterWithOnlyLetter, numberWithCommas, totalPriceDisplay, totalPriceDisplayforDiscount, totalCarat, translationMap, Slugs, appendDetailsNewTabQuery } from '../../../../helper';
import Loader from '../../../layout/Loader';
// import { diamondsJson, selectActionJson } from '../../../../utils/json';
import { diamondsJson, selectActionJson, selectActionJsonDiamonds } from '../../../../utils/json';
import $ from 'jquery';
import { getCategory } from '../../../../actions/categoryAction';
import { useAlert } from 'react-alert';
import ReactPaginate from "react-paginate";
import Popup from '../popup';
import PopupConfirm from '../../../layout/PopupConfirm';
import MyProductsSideFilter from '../../../products/whiteDimonds/MyProductsSideFilter';

const normDiamondStock = (v) => (v == null ? '' : String(v).trim());

/** Current page only — pair_stock_no set, or another row's pair_stock_no matches this stock_number. */
const diamondRowIsPairedInPage = (row, pageRows) => {
    if (!row) return false;
    if (normDiamondStock(row.pair_stock_no) !== '') return true;
    const sn = normDiamondStock(row.stock_number);
    if (!sn || !pageRows?.length) return false;
    const lower = sn.toLowerCase();
    return pageRows.some(
        (r) =>
            r &&
            String(r.id) !== String(row.id) &&
            normDiamondStock(r.pair_stock_no) !== '' &&
            normDiamondStock(r.pair_stock_no).toLowerCase() === lower
    );
};

const WhiteDimonds = (props) => {

    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();
    const alert = useAlert();
    const category_slug = getLastURL(location);
    const { myproduct, loading } = useSelector(state => state.myproduct);
    const [activeFilters, setActiveFilters] = useState({});

    const productFilter = useSelector(state => state.DownloadPdfWithFilterState)
    const { myproductselectaction } = useSelector(state => state.myproductselectaction);
    const { myproductstatusaction } = useSelector(state => state.myproductstatusaction);
    const { myproductactiveall } = useSelector(state => state.myproductactiveall);
    const free_ad_purchase_data = useSelector(state => state.AdvertisementFreePurchaseState);
    const getUrlToDownloadForUser = useSelector(state => state.getUrlToDownloadForUserState);

    const [filterdisplayname, setFilterDisplayName] = useState(<FormattedMessage id="Select Sort Option" />);
    const [actionname, setActionName] = useState(<FormattedMessage id="Actions" />)
    const [search, setSearch] = useState();
    const [currentPage, setCurrentPage] = useState(0);
    const [postsPerPage, setPostPerPage] = useState(postPerPage);

    const [selectAllStock, setSelectAllStock] = useState(new Array(myproduct && myproduct.products && myproduct.products.data && myproduct.products.data.length).fill(false));
    const [selectedAction, setSeletedAction] = useState();
    const [selectedId, setSelectedId] = useState([]);
    const selectedArray = [];
    const [checkHead, setCheckHead] = useState(false);
    const [sold, setSold] = useState(false);
    const { checkPlan } = useSelector(state => state.checkPlanReducer);
    const [prod_id, setCurrentId] = useState(0);
    const [showFilters, setShowFilters] = useState(false);
    const [sideFilters, setSideFilters] = useState();
    const pathname = getLastURL(location);
    const { attributes } = useSelector((state) => state.attributes);
    const intl = useIntl();
    const [singleDeleteConfirm, setSingleDeleteConfirm] = useState(null);
    const [bulkDeleteConfirm, setBulkDeleteConfirm] = useState(null);
    const [sellerActionConfirm, setSellerActionConfirm] = useState(null);

    const handlePageChange = ({ selected }) => {
        props.updateResetPageHandler(selected)

        if (sideFilters) {
            dispatch(getAllMyProductsFilter(category_slug, sideFilters, (selected + 1)));
        } else {
            dispatch(myProductAction(category_slug, (selected + 1)));
        }
    }

    const pageCount = Math.ceil((myproduct && myproduct.products && myproduct.products.total) / postsPerPage);

    const handleAcendingFilter = (value, type, displayname) => {
        setFilterDisplayName(displayname)
        $('.sort_by_list').css({
            display: "none"
        })
        props.tabChangeHandler(1)
        dispatch(myProductFilterByAscending(category_slug, value, type))
    }

    const handleSearch = (e) => {
        setSearch(e.target.value);
    }

    const handleSearchFilter = (e) => {
        if (e.key === 'Enter') {
            dispatch(myProductFilter(category_slug, { search: search }));
        }
    }
    const handleSearchIconClick = () => {
        dispatch(myProductFilter(category_slug, { search: search }));
    };

    useEffect(() => {
        if (getUrlToDownloadForUser?.documentDetail?.pdf_url) {
            const link = document.createElement('a');
            // link.href = products?.pdf_url;
            window.open(getUrlToDownloadForUser?.documentDetail?.pdf_url)
            link.download = 'diamonds.pdf';
            document.body.appendChild(link);
            link.click();
            dispatch({
                type: "DOWNLOAD_DIAMOND_EXCEL_FOR_USER_FAIL",
                payload: null
            })
        }
    }, [getUrlToDownloadForUser])

    const handleStockManagement = (id, position) => {
        const updatedSelectAllStock = selectAllStock && selectAllStock.map((item, index) => {
            if (index === position) {
                return !item;
            } else {
                return item;
            }
        });
        setSelectAllStock(updatedSelectAllStock);

        if (!selectedId.includes(id)) {
            setSelectedId([...selectedId, id]);
        } else {
            selectedId.splice(selectedId.indexOf(id), 1);
        }
    }

    const handlecheckPlan = (id) => {
        // dispatch(checkAdvertisementPlan(id));
        dispatch(AdvertisementFreePurchaseAction(id));
        setCurrentId(id);
    }

    const selectAll = (selectAllStock) => {
        if (selectAllStock.every(e => e === false)) {
            setSelectAllStock(new Array(myproduct && myproduct.products && myproduct.products.data && myproduct.products.data.length).fill(true));

            myproduct && myproduct.products && myproduct.products.data && myproduct.products.data.map((data, key) => {
                selectedArray.push(data.id);
            })
            setCheckHead(true);
            setSelectedId(selectedArray);

        } else {
            setSelectAllStock(new Array(myproduct && myproduct.products && myproduct.products.data && myproduct.products.data.length).fill(false));
            selectedArray.pop();
            setSelectedId([]);
            setCheckHead(false);
        }
    }

    const handleSelectAction = (event, value) => {

        $('.sort_by_action').css({
            display: "none"
        })

        if(value == "select_item_download"){
           if(selectedId?.length > 0){
           return  dispatch(getUrlToDownloadForUserAction(category_slug, selectedId , false, 'excel_all'));
           } 
        }
        if(myproduct?.products?.data?.length == 0 && value == "excel_all"){
                alert.error('There’s no data to download as an Excel file right now.');
             return   
        }
            if (value == 'excel_all') {
                dispatch(getUrlToDownloadForUserAction(category_slug, [], true, "excel_all", productFilter?.data?.filter));
            }

        else {
            if (selectedId.every(e => e === false) || selectedId === null) {
                alert.error('Please select stock');
                setSeletedAction("");
                return;
            }
            if (value === "delete") {
                const ids = selectedId.filter((x) => x !== false && x != null);
                if (ids.length === 0) {
                    alert.error('Please select stock');
                    setSeletedAction("");
                    return;
                }
                const rows =
                    myproduct?.products?.data?.filter((p) =>
                        ids.some((id) => String(id) === String(p.id))
                    ) || [];
                const hasPair = rows.some(
                    (r) =>
                        r?.pair_stock_no != null &&
                        String(r.pair_stock_no).trim() !== ""
                );
                setBulkDeleteConfirm({ isPair: hasPair, ids: [...ids] });
                setTimeout(() => {
                    $("#popup-click-confirm-bulk-delete").trigger("click");
                }, 0);
                return;
            }
            const bulkPairActions = ['active', 'deactivate', '2316', '2320', 'outofstock'];
            if (bulkPairActions.includes(String(value))) {
                const ids = selectedId.filter((x) => x !== false && x != null);
                if (ids.length === 0) {
                    alert.error('Please select stock');
                    setSeletedAction('');
                    return;
                }
                const pageRows = myproduct?.products?.data || [];
                const rows =
                    pageRows.filter((p) =>
                        ids.some((id) => String(id) === String(p.id))
                    ) || [];
                const hasPair = rows.some((r) => diamondRowIsPairedInPage(r, pageRows));
                setSellerActionConfirm({
                    scope: 'bulk',
                    ids: [...ids],
                    action: value,
                    isPair: hasPair,
                });
                setTimeout(() => {
                    $('#popup-click-confirm-seller-action').trigger('click');
                }, 0);
                return;
            }
            setSeletedAction(value);
            dispatch(myProductSelectAction(selectedId, value));
            dispatch(GetProductCount());
            setSold(false);
        }
    }

    const handleActiveAll = async () => {
        await dispatch(myProductActiveAll());
        dispatch(myProductAction(category_slug));
        dispatch(GetProductCount());
        dispatch(getCategory());

    }

    const handleInActiveAll = async () => {
        await dispatch(myProductDeactiveAll(category_slug));
        dispatch(myProductAction(category_slug));
        dispatch(GetProductCount());
        dispatch(getCategory());

    }

    const handleResForm = async (status) => {
        if (status) {
            await dispatch(myProductDeleteAll(category_slug));
            await dispatch(myProductAction(category_slug));
            await dispatch(GetProductCount());
            await dispatch(getCategory());
        }
        $("#dismiss-modal").trigger('click');

    }

    const handleDeleteAllClick = (event) => {
        $("#popup-click-confirm").trigger('click');
    }

    // useEffect(() => {
    //     if (checkPlan) {
    //         if (checkPlan?.data) {
    //             history.push(url + `/advertise-plan-details/${prod_id}`);
    //         } else {
    //             alert.error(checkPlan['message']);
    //         }
    //         dispatch(checkAdvertisementPlan("RESET"));
    //     }
    //     //setCurrentId([]);
    // }, [checkPlan])

    useEffect(() => {
        if (free_ad_purchase_data?.data) {
            if (free_ad_purchase_data?.data?.data) {
                // history.push(url + `/advertise-plan-details/${prod_id}`);
                alert.success("Item Advertised")
            } else {
                alert.error(free_ad_purchase_data?.data['message']);
            }
            dispatch(AdvertisementFreePurchaseAction("RESET"));
        }
        //setCurrentId([]);
    }, [free_ad_purchase_data?.data])

    useEffect(() => {
        if (myproductselectaction) {
            alert.success(myproductselectaction);
            dispatch(clearMessage());
            setSelectAllStock([]);
            setSelectedId([]);

            setCheckHead(false);
            setSeletedAction("");
            dispatch(myProductAction(category_slug));
            dispatch(getCategory());
            return
        }
        if (myproductactiveall) {
            alert.success(<div className="react-alert-change-css">{myproductactiveall}</div>);
            dispatch(clearMessage());
            return
        }

        if (myproductstatusaction) {
            alert.success(<div className="react-alert-change-css">{myproductstatusaction}</div>);
            dispatch(clearMessage());
            return
        }
    }, [myproductselectaction, myproductactiveall, myproductstatusaction])

    const handleSoldProducts = (event) => {
        setSold(event.target.checked);
        dispatch(myProductShowSold(category_slug, event.target.checked));
    }

    const openSingleListDelistConfirm = (e, row, action) => {
        e.preventDefault();
        e.stopPropagation();
        const pageRows = myproduct?.products?.data || [];
        const isPair = diamondRowIsPairedInPage(row, pageRows);
        setSellerActionConfirm({
            scope: 'singleListDelist',
            id: row.id,
            action,
            isPair,
        });
        setTimeout(() => {
            $('#popup-click-confirm-seller-action').trigger('click');
        }, 0);
    };

    const openSingleStatusConfirm = (e, row, action) => {
        e.preventDefault();
        e.stopPropagation();
        const pageRows = myproduct?.products?.data || [];
        const isPair = diamondRowIsPairedInPage(row, pageRows);
        setSellerActionConfirm({
            scope: 'singleStatus',
            id: row.id,
            action,
            isPair,
        });
        setTimeout(() => {
            $('#popup-click-confirm-seller-action').trigger('click');
        }, 0);
    };

    const handleSellerActionResForm = async (status) => {
        const pending = sellerActionConfirm;
        setSellerActionConfirm(null);
        if (!status || !pending) {
            return;
        }
        if (pending.scope === 'singleListDelist') {
            await dispatch(myProductSelectAction([pending.id], pending.action));
            await dispatch(myProductAction(category_slug));
            dispatch(GetProductCount());
            dispatch(getCategory());
            return;
        }
        if (pending.scope === 'singleStatus') {
            await dispatch(myProductStatusAction(pending.id, pending.action));
            await dispatch(myProductAction(category_slug));
            dispatch(GetProductCount());
            dispatch(getCategory());
            return;
        }
        if (pending.scope === 'bulk') {
            setSeletedAction(pending.action);
            await dispatch(myProductSelectAction(pending.ids, pending.action));
            dispatch(GetProductCount());
            setSold(false);
        }
    };

    const sellerActionConfirmMessage = () => {
        const p = sellerActionConfirm;
        if (!p) {
            return '';
        }
        if (p.scope === 'bulk') {
            if (p.isPair) {
                return intl.formatMessage({
                    id: 'pairDiamondBulkSameAction',
                    defaultMessage:
                        'One or more selected items are in a matched pair. The pair product(s) will get the same change. Continue?',
                });
            }
            const a = String(p.action);
            if (a === 'active') {
                return intl.formatMessage({
                    id: 'confirmDiamondListBulk',
                    defaultMessage: 'Are you sure you want to list the selected items?',
                });
            }
            if (a === 'deactivate') {
                return intl.formatMessage({
                    id: 'confirmDiamondDelistBulk',
                    defaultMessage: 'Are you sure you want to unlist the selected items?',
                });
            }
            if (a === '2316') {
                return intl.formatMessage({
                    id: 'confirmDiamondAvailableBulk',
                    defaultMessage: 'Are you sure you want to set the selected items to Available?',
                });
            }
            if (a === '2320') {
                return intl.formatMessage({
                    id: 'confirmDiamondMemoBulk',
                    defaultMessage: 'Are you sure you want to set the selected items to On Memo?',
                });
            }
            if (a === 'outofstock') {
                return intl.formatMessage({
                    id: 'confirmDiamondSoldBulk',
                    defaultMessage:
                        'Are you sure you want to mark the selected items as Sold?',
                });
            }
            return '';
        }
        if (p.scope === 'singleListDelist') {
            if (p.isPair) {
                return p.action === 'active'
                    ? intl.formatMessage({
                          id: 'pairDiamondListPartnerWarning',
                          defaultMessage:
                              'This diamond is in a matched pair. Your pair product will also be listed. Continue?',
                      })
                    : intl.formatMessage({
                          id: 'pairDiamondDelistPartnerWarning',
                          defaultMessage:
                              'This diamond is in a matched pair. Your pair product will also be unlisted. Continue?',
                      });
            }
            return p.action === 'active'
                ? intl.formatMessage({
                      id: 'confirmDiamondListSingle',
                      defaultMessage: 'Are you sure you want to list this product?',
                  })
                : intl.formatMessage({
                      id: 'confirmDiamondDelistSingle',
                      defaultMessage: 'Are you sure you want to unlist this product?',
                  });
        }
        if (p.scope === 'singleStatus') {
            const act = String(p.action);
            if (p.isPair) {
                return act === '2316'
                    ? intl.formatMessage({
                          id: 'pairDiamondAvailablePartnerWarning',
                          defaultMessage:
                              'This diamond is in a matched pair. Your pair product will also be set to Available. Continue?',
                      })
                    : intl.formatMessage({
                          id: 'pairDiamondMemoPartnerWarning',
                          defaultMessage:
                              'This diamond is in a matched pair. Your pair product will also be set to On Memo. Continue?',
                      });
            }
            return act === '2316'
                ? intl.formatMessage({
                      id: 'confirmDiamondAvailableSingle',
                      defaultMessage: 'Are you sure you want to set this product to Available?',
                  })
                : intl.formatMessage({
                      id: 'confirmDiamondMemoSingle',
                      defaultMessage: 'Are you sure you want to set this product to On Memo?',
                  });
        }
        return '';
    };

    const openSingleDeleteConfirm = (e, row) => {
        e.preventDefault();
        e.stopPropagation();
        const hasPair =
            row?.pair_stock_no != null && String(row.pair_stock_no).trim() !== "";
        setSingleDeleteConfirm({ id: row.id, isPair: hasPair });
        setTimeout(() => {
            $("#popup-click-confirm-single-delete").trigger("click");
        }, 0);
    };

    const handleSingleDeleteResForm = async (status) => {
        const pending = singleDeleteConfirm;
        setSingleDeleteConfirm(null);
        if (status && pending) {
            await dispatch(myProductSelectAction([pending.id], "delete"));
            await dispatch(myProductAction(category_slug));
            dispatch(GetProductCount());
            dispatch(getCategory());
        }
    };

    const handleBulkDeleteResForm = async (status) => {
        const pending = bulkDeleteConfirm;
        setBulkDeleteConfirm(null);
        if (status && pending?.ids?.length) {
            setSeletedAction("delete");
            await dispatch(myProductSelectAction(pending.ids, "delete"));
            await dispatch(myProductAction(category_slug));
            dispatch(GetProductCount());
            dispatch(getCategory());
            setSold(false);
        }
    };

    const handleDetails = (id) => {
          window.open(appendDetailsNewTabQuery(`${url}/details/diamonds/${id}`), '_blank');
        // window.location.href = `${url + `/details/diamonds/${id}`}`
        // history.push(url + `/details/diamonds/${id}`);
    }

    const handleFilter = (keyToRemove) => {
        const updatedFilter = Object.entries(activeFilters).filter(([key]) => key !== keyToRemove).reduce((acc, [key, value]) => {
            if (key === 'carat' || key === 'no_BGM' || key === 'is_fancy' || key === 'price') {
                acc[key] = value;
                return acc;
            } else {
                acc[key] = value.map(item => item.attribute_id);
                return acc;
            }
        }, {})

        setActiveFilters(updatedFilter);
        dispatch(getAllMyProductsFilter(pathname, updatedFilter , 1));
    };
    useEffect(() => {
        if (loading) return;
        if (myproduct?.category?.slug && myproduct.category.slug !== category_slug) return;
        if (myproduct?.filter && Object.keys(myproduct.filter).length > 0) {
            setActiveFilters(myproduct.filter);
        } else {
            setActiveFilters({});
        }
    }, [myproduct, loading, category_slug]);

    const comaSeperatedFilter = (arr) => {
        let val = ""
        if (Array.isArray(arr)) {
            for (let i = 0; i < arr.length; i++) {
                val += arr[i].display_name + (i === arr.length - 1 ? '' : ', ');
            }
        } else {
            return arr;
        }
        return val;
    }


    useEffect(() => {
        setActiveFilters({});
        setSideFilters(undefined);
        localStorage.removeItem(category_slug + "filter");
        dispatch(myProductFilter(category_slug, {}));
        dispatch(getAllDiamondsProductsFilter(category_slug, {}));
        dispatch(myProductAction(category_slug, 1));
    }, [category_slug, dispatch]);


    return (
        <Fragment>
            {/* {(loading || free_ad_purchase_data?.loading || getUrlToDownloadForUser?.loading) && <Loader />} */}
            <Fragment>
                <div className="col-xl-10 col-lg-9 col-md-9 col-sm-8">
                    {(loading || free_ad_purchase_data?.loading || getUrlToDownloadForUser?.loading) ? <div class="loader-line"></div> : ""}
                    <div className="titles mt-4 mb-3 pb-3">
                        <div className="row">
                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                <h2 className="m-0"><FormattedMessage id="category.diamonds" />
                                    <span className="pro_nub w-auto px-2"> {myproduct && myproduct?.products && myproduct?.products?.total} </span>
                                </h2>
                            </div>

                            <div className="col-xl-9 col-lg-8 col-sm-6 col-md-6 hides ">
                                {/* <div className=" form-group ml-3 form-inline">
                                <button className="btn-black active-all" data-toggle="modal" data-target="#popup"><span><span className="fa fa-check"></span><span>{` `}</span>Pop up form</span></button>
                            </div> */}
                                <div className=" form-group ml-3 form-inline">
                                    <Link to={url + `/advertisement/diamonds`} >
                                        <button type="button" className="btn-black active-all">
                                            <span>
                                                <span className="fas fa-ad"></span>
                                                <span>{` `}</span>
                                                <FormattedMessage id="Advertisement" defaultMessage="Advertisement Histroy" />
                                            </span>
                                        </button>
                                    </Link>
                                </div>
                                <div className=" form-group ml-3 form-inline">
                                    <button type="button" className="btn-black active-all" onClick={handleActiveAll}><span><span className="fa fa-check"></span><span>{` `}</span> <FormattedMessage id="UpdateMyListings" defaultMessage="Update My Listingsss" /></span></button>
                                </div>
                                <div className=" form-group ml-3 form-inline">
                                    <button type="button" className="btn-black active-all" onClick={handleInActiveAll}><span><span className="fa fa-close"></span><span>{` `}</span> <FormattedMessage id="UnlistAllItems" defaultMessage="Unlist All Items" /></span></button>
                                </div>
                                <div className=" form-group ml-3 form-inline">
                                    <button type="button" className="btn-black active-all" onClick={handleDeleteAllClick}><span><span className="fa fa-trash"></span><span>{` `}</span> <FormattedMessage id="DeleteAllItems" defaultMessage="Delete All Items" /></span></button>
                                </div>
                                <div className="form-group mb-0 form-inline">
                                    <Link to={url + '/add-product'}>
                                        <button type="button" className="btn-black">
                                            <span className="icon-add_1"></span>
                                            <span>{` `}</span>
                                            <FormattedMessage
                                                id="addsingleproduct.add-new-product"
                                                defaultMessage="Add New Items"
                                            />
                                        </button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={'side-filter-overlay' + (showFilters ? " show" : "")} onClick={() => setShowFilters(false)}></div>
                    <div className={'side-filter' + (showFilters ? " open" : "")}>
                        <div className='side-filter-inner '>
                            <button
                                className='close-filter'
                                id="close-side-filter"
                                onClick={() => setShowFilters(false)}
                            >&times;</button>
                            <div className='row'>
                                <MyProductsSideFilter setShowFilters={setShowFilters} setSideFilters={setSideFilters} resetPage={props.updateResetPageHandler} />
                            </div>
                        </div>
                    </div>
                    <div className="titles mt-4  border-0">
                        <div className="filter_search_right">
                            <div className="search_cat_top border-0">
                                <div className="row">

                                    <div className="col-lg-12 col-md-12 col-sm-12 d-flex flex-wrap justify-content-md-end">
                                        <div className="form-group mb-0 mr-3 form-inline ">
                                            <input type="checkbox" id="sold" checked={sold} onChange={handleSoldProducts} />
                                            <label htmlFor="sold" className="mt-2"><FormattedMessage id="Show sold products" /></label>
                                        </div>
                                        <div className="form-group pb-0 sort_by_box">
                                            <p className="sort_b_h text-right side-dropdown" onClick={handleSortBy}>
                                                <b className="mr-2"><FormattedMessage id="Sort_By" />:</b>
                                                {filterdisplayname} <span className="icon-chevron_down">
                                                </span>
                                            </p>
                                            <div className="sort_by_list">
                                                <ul>
                                                    {
                                                        diamondsJson && diamondsJson.map((data, key) => {
                                                            return (
                                                                <li className="activess" onClick={() => handleAcendingFilter(data.value, data.type, data.display_name)}>{data.display_name}</li>
                                                            )
                                                        })
                                                    }
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row filter_search_right align-items-center justify-content-between" >
                        <div className="col-lg-6 col-md-6">
                            <div className="d-flex">
                                {/* <button
                                    type="button"
                                    className="btn-black active-all mb-3 mt-2"
                                    onClick={() => setShowFilters(true)}>
                                    <span>
                                        <span className="fas fa-filter"></span>
                                        <span>{' '}</span>
                                        <FormattedMessage
                                            id="addsingleproduct.all-filters"
                                            defaultMessage="All Filters"
                                        />
                                    </span>
                                </button> */}
                                <div className="filter_search_right">
                                    <div className="search_cat_top border-0">
                                        <div className="form-group pb-0 sort_by_box">
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <button className='all-filters-btn' onClick={() => setShowFilters(true)} type='button'><img src={IMAGES.filterIcon} alt="filter-icon" />
                                                    <FormattedMessage
                                                        id="addsingleproduct.all-filters"
                                                        defaultMessage="All Filters"
                                                    />
                                                </button>
                                                {/* <p className="sort_b_h text-right" onClick={() => setShowFilters(true)}>
                                                    <FormattedMessage
                                                        id="addsingleproduct.all-filters"
                                                        defaultMessage="All Filters"
                                                    />
                                                    <span className="icon-chevron_down"></span>
                                                </p> */}
                                                <p className="sort_b_h text-right ms-3" onClick={handleSortByAction}>
                                                    {/* <b className="mr-2">
                                                        <FormattedMessage id="Select Actions" />:</b> */}
                                                    {actionname}
                                                    <span className="icon-chevron_down"></span>
                                                </p>
                                            </div>
                                            <div className="sort_by_action" style={{ width: "max-content" }}>
                                                <ul>

                                                    {
                                                        selectActionJsonDiamonds?.length && selectActionJsonDiamonds?.map((data, key) => {
                                                            return (
                                                                <li key={key}
                                                                    className="activess"
                                                                    onClick={(e) => handleSelectAction(e, data.value)}>
                                                                    {data.display_name}
                                                                </li>
                                                            )
                                                        })
                                                    }
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className=" col-lg-4 col-md-4 col-sm-4">
                            <div className="seach_filter position-relative">
                                <input
                                    type="text"
                                    value={search}
                                    onKeyPress={(e) => handleSearchFilter(e)}
                                    onChange={handleSearch}
                                    className="form-control"
                                    placeholder={useIntl().formatMessage({ id: 'SearchByStock' })}
                                />
                                <span className="icon-search_1  input_icon position-absolute" onClick={handleSearchIconClick} style={{ cursor: 'pointer' }}></span>
                            </div>
                        </div>
                    </div>

                    <div className='d-flex flex-wrap gap-3'>
                        {
                            activeFilters && Object.keys(activeFilters).length > 0 ?
                                Object.entries(activeFilters).map(([key, value]) => {
                                    if (key == 'type') {
                                                        return
                                                      }
                                    if (key == "carat") {
                                        return (
                                            <div className='filter_search_right'>
                                                <div className='search_cat_top border-0'>
                                                    <div className="s_c" key={key}>
                                                        <p>
                                                            <span className='first-letter'>
                                                                <b>Carat:</b> {value?.from} - {value?.to}
                                                            </span>
                                                            <button
                                                                className='text-black border-0 p-0 bg-none ml-3'
                                                                style={{ outline: 'none' }}
                                                                onClick={() => handleFilter(key)}
                                                            >
                                                                <i className='icon-close_1 ml-0'></i>
                                                            </button>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }
                                    if (key == 'is_fancy') {
                                        return (
                                            <div className='filter_search_right'>
                                            <div className='search_cat_top border-0'>
                                            <div className="s_c" key={key}>
                                                <p style={{ marginLeft: '10px' }}>
                                                    <span className='first-letter'>
                                                        <b>Fancy</b>: {value == '1' ? 'Yes' : 'No'}
                                                    </span>
                                                    <button
                                                        className='text-black border-0 p-0 bg-none ml-3'
                                                        style={{ outline: 'none' }}
                                                        onClick={() => handleFilter(key)}
                                                    >
                                                        <i className='icon-close_1 ml-0'></i>
                                                    </button>
                                                </p>
                                            </div>
                                            </div>
                                            </div>
                                        )
                                    }
                                    let translatedKey = localStorage.getItem('lang') === 'tr' ? translationMap[key] : key;
                                    return (
                                        <div className='filter_search_right'>
                                            <div className='search_cat_top border-0'>
                                                <div className="s_c" key={key}>
                                                    <p>
                                                        <span className='first-letter'>
                                                            <b>{translatedKey}:</b> {comaSeperatedFilter(value)}
                                                        </span>
                                                        <button
                                                            className='text-black border-0 p-0 bg-none ml-3'
                                                            style={{ outline: 'none' }}
                                                            onClick={() => handleFilter(key)}
                                                        >
                                                            <i className='icon-close_1 ml-0'></i>
                                                        </button>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                                : ""
                        }
                    </div>
                    <div className="tbles mb-5">
                        <table width="100%">
                            <tr>
                                <th>
                                    <div className="form-group mb-0 mini checks inss">
                                        <input className="" type="checkbox" id="checkall" checked={checkHead} onChange={() => selectAll(selectAllStock)} />
                                        <label htmlFor="checkall"></label>
                                    </div>
                                </th>
                                <th><FormattedMessage id="addsingleproduct.stockno" /></th>
                                <th><FormattedMessage id="Shape" defaultMessage="Shape" /></th>
                                <th><FormattedMessage id="addsingleproduct.carat" defaultMessage="Carat" /></th>
                                {
                                    myproduct && myproduct?.is_fancy == 1 ?
                                        <>
                                            <th><FormattedMessage id="Intensity" defaultMessage="Intensity" /></th>
                                            <th><FormattedMessage id="Overtone" defaultMessage="Overtone" /></th>
                                        </>
                                        : ""
                                }
                                <th><FormattedMessage id="addsingleproduct.color" defaultMessage="Color" /></th>
                                <th><FormattedMessage id="addsingleproduct.clarity" defaultMessage="Clarity" /></th>
                                <th><FormattedMessage id="addsingleproduct.cut" defaultMessage="Cut" /></th>
                                <th><FormattedMessage id="addsingleproduct.pol" defaultMessage="Pol" /></th>
                                <th><FormattedMessage id="addsingleproduct.sym" defaultMessage="Sym" /></th>
                                <th><FormattedMessage id="addsingleproduct.Fluor" defaultMessage="Fluor" /></th>
                                <th><FormattedMessage id="Milky" defaultMessage="Milky" /></th>
                                <th><FormattedMessage id="Bgm" defaultMessage="BGM" /></th>
                                <th><FormattedMessage id="Cert" defaultMessage="Cert" /></th>
                                <th > <FormattedMessage id="addsingleproduct.view_count"  defaultMessage="view count">
                                    {(msg) => (
                                    <i className="fas fa-eye" title={msg}></i>
                                    )}
                                </FormattedMessage>
                                </th>
                                <th>
                                <FormattedMessage id="addsingleproduct.favorites"  defaultMessage="Favorites">
                                    {(msg) => (
                                    <i className="fa fa-heart" title={msg}></i>
                                    )}
                                </FormattedMessage>
                                </th>
                                <th><FormattedMessage id="addsingleproduct.price_ct" /></th>
                                <th><FormattedMessage id="Disc" defaultMessage="Disc" /></th>
                                <th><FormattedMessage id="addsingleproduct.price" /></th>
                                <th><FormattedMessage id="Status" defaultMessage="Status" /></th>
                                <th><FormattedMessage id="Actions" /></th>
                            </tr>

                            {
                                myproduct && myproduct?.products && myproduct?.products?.data?.length > 0 ?
                                    myproduct && myproduct?.products && myproduct?.products?.data && myproduct?.products?.data?.map((data, key) => {
                                        return (
                                            <tr>
                                                <td>
                                                    <div className="form-group mb-0 mini inss">
                                                        <input
                                                            type="checkbox"
                                                            id={data.id}
                                                            name="check"
                                                            checked={selectAllStock[key]}
                                                            onChange={() => handleStockManagement(data.id, key)}
                                                        />
                                                        <label htmlFor={data.id}></label>
                                                    </div>
                                                </td>
                                                <td onClick={(e) => handleDetails(data.id)}>{data && data.stock_number}</td>
                                                <td onClick={(e) => handleDetails(data.id)}>{pColmDisplay(data, 'a_shape')}</td>
                                                <td onClick={(e) => handleDetails(data.id)}>{data && data.carat && totalCarat(data)}</td>
                                                {
                                                    myproduct && myproduct?.is_fancy == 1 ?
                                                        <>
                                                            <td onClick={(e) => handleDetails(data.id)}>{pColmDisplay(data, 'a_fancy_intensity')}</td>
                                                            <td onClick={(e) => handleDetails(data.id)}>{pColmDisplay(data, 'a_fancy_overtone')}</td>
                                                            <td onClick={(e) => handleDetails(data.id)}>{pColmDisplay(data, 'a_fancy_color')}</td>
                                                        </>
                                                        :
                                                        <td onClick={(e) => handleDetails(data.id)}>{pColmDisplay(data, 'a_color')}</td>
                                                }
                                                <td onClick={(e) => handleDetails(data.id)}>{pColmDisplay(data, 'a_clarity')}</td>
                                                <td onClick={(e) => handleDetails(data.id)}>{data && data.a_cut && capitalizeFirstLetterWithOnlyLetter(pColmDisplay(data, 'a_cut'))}</td>
                                                <td onClick={(e) => handleDetails(data.id)}>{data && data.a_polish && capitalizeFirstLetterWithOnlyLetter(pColmDisplay(data, 'a_polish'))}</td>
                                                <td onClick={(e) => handleDetails(data.id)}>{data && data.a_symmetry && capitalizeFirstLetterWithOnlyLetter(pColmDisplay(data, 'a_symmetry'))}</td>
                                                <td onClick={(e) => handleDetails(data.id)}>{data && data.a_fluorescence && capitalizeFirstLetterWithOnlyLetter(pColmDisplay(data, 'a_fluorescence'))}</td>

                                                <td onClick={(e) => handleDetails(data.id)}>{pColmDisplay(data, 'milky')}</td>
                                                <td onClick={(e) => handleDetails(data.id)}>{data && data['bgm'] == "0" ? 'Yes' : "No"} </td>

                                                {/* {data && data.certificate_url ?
                                                    <td><a href={GenerateCertificatePdf(data.certificate_url)} target={GenerateCertificatePdf(data.certificate_url)}>{pColmDisplay(data, 'a_certificate')}</a></td>
                                                    :
                                                    <td>{pColmDisplay(data, 'a_certificate')}</td>
                                                } */}
                                                {
                                                    (() => {
                                                        if (data && data.certificate_url) {
                                                            return <td><a href={GenerateCertificatePdf(data.certificate_url)} target={GenerateCertificatePdf(data.certificate_url)}>{pColmDisplay(data, 'a_certificate')}</a></td>
                                                        }
                                                        else if (pColmDisplay(data, 'a_certificate') == "HRD") {
                                                            return <td><a href={hrdurl + data.certificate_number} target="_blank">{pColmDisplay(data, 'a_certificate')}</a></td>
                                                        } else if (data.certificate == "25" && pColmDisplay(data, 'a_certificate') == "GIA") {
                                                            return <td><a href={giaurl + data.certificate_number} target="_blank">{pColmDisplay(data, 'a_certificate')}</a></td>
                                                        } else {
                                                            return <td>{pColmDisplay(data, 'a_certificate')}</td>
                                                        }
                                                    })()
                                                }

                                                <td onClick={(e) => handleDetails(data.id)}>{data && data?.views_count}</td>
                                                <td onClick={(e) => handleDetails(data.id)}>{data && data?.favorite_count}</td>
                                                <td>${data && data.price && numberWithCommas(parseFloat(data.price).toFixed(2))}</td>
                                                <td onClick={(e) => handleDetails(data.id)}>
                                                    {data && data?.discount && totalPriceDisplayforDiscount(data)} </td>
                                                <td onClick={(e) => handleDetails(data.id)}>{
                                                    totalPriceDisplay(data)}</td>

                                                <td className="text-right Active-st-td">
                                                    <span
                                                        style={{ color: data && data?.availability_status?.attribute_id === 2316 ? 'green' : 'red', fontWeight: '600' }}>
                                                        {pColmDisplay(data, 'availability_status')}
                                                    </span>
                                                    <div className="more">
                                                        <span><img src={IMAGES.THREE_DOT} alt="" /></span>
                                                        <ul>
                                                            {
                                                                data && data?.availability_status?.attribute_id === 2316 ?
                                                                    <li onClick={(e) => openSingleStatusConfirm(e, data, 2320)}><h6><FormattedMessage id="On_Memo" /></h6></li>
                                                                    :
                                                                    <li onClick={(e) => openSingleStatusConfirm(e, data, 2316)}><h6><FormattedMessage id="Available" /></h6></li>
                                                            }
                                                        </ul>
                                                    </div>
                                                </td>
                                                <td className="text-right Active-st-td">
                                                    <span style={{ color: data.status === 1 ? 'green' : 'red', fontWeight: '600' }}>
                                                        {data.status === 1 ? <FormattedMessage id="Listed" /> : <FormattedMessage id="Unlisted" />}
                                                    </span>
                                                    <div className="more">
                                                        <span><img src={IMAGES.THREE_DOT} alt="" /></span>
                                                        <ul>
                                                            <li>
                                                                <h6 onClick={(e) => handlecheckPlan(data.id)}>
                                                                    <FormattedMessage id="Advertise This Item" />
                                                                </h6>
                                                            </li>
                                                            <li>
                                                                <Link
                                                                    // to={{ pathname: url + '/edit-full-product/' + data.id }}
                                                                    to={{ pathname: `${url}/edit-full-product/${Slugs?.Diamonds}/${data.id}` }}
                                                                    style={{ paddingTop: '0px' }}>
                                                                    <h6><FormattedMessage id="Edit Product" /></h6>
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link
                                                                    to={{
                                                                        pathname: url + '/edit-product/' + data?.id,
                                                                        // query: {
                                                                        //     'discount': data.discount,
                                                                        //     'price': data.price,
                                                                        //     category_slug
                                                                        // }
                                                                        search: `?discount=${data?.discount}&price=${data?.price}&category_slug=${category_slug}&is_fancy=${data?.is_fancy}`
                                                                    }}
                                                                    style={{ paddingTop: '0px' }}>
                                                                    <h6><FormattedMessage id="Edit Price" /></h6>
                                                                </Link>
                                                            </li>
                                                            {
                                                                data?.status === 1 ?
                                                                    <li onClick={(e) => openSingleListDelistConfirm(e, data, 'deactivate')}>
                                                                        <h6><FormattedMessage id="Unlist Item" /></h6>
                                                                    </li>
                                                                    :
                                                                    <li onClick={(e) => openSingleListDelistConfirm(e, data, 'active')}>
                                                                        <h6><FormattedMessage id="List Item" /></h6>
                                                                    </li>
                                                                // <img src={IMAGES.EDIT_PNG} className="mr-2" alt="" />
                                                            }
                                                            <li onClick={(e) => openSingleDeleteConfirm(e, data)}>
                                                                <h6><FormattedMessage id="Delete" /></h6>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })
                                    :
                                    <tr>
                                        <th colspan="18">
                                            <FormattedMessage id="ProductNotFound" defaultMessage="Product not Found" />
                                        </th>
                                    </tr>
                            }

                        </table>
                    </div>
                    {
                        myproduct?.products?.total > 0 ?
                            <div className="table_pagination">
                                <ReactPaginate
                                    previousLabel={<i className="icon icon-chevron_gray-left"></i>}
                                    nextLabel={<i className="icon icon-chevron_black"></i>}
                                    pageCount={pageCount}
                                    onPageChange={handlePageChange}
                                    containerClassName={"paginationBttns"}
                                    previousLinkClassName={myproduct?.products?.total ? "previousBttn" : ""}
                                    nextLinkClassName={myproduct?.products?.total ? "nextBttn" : ""}
                                    disabledClassName={"paginationDisabled"}
                                    activeClassName={"paginationActive"}
                                    forcePage={props?.pageReset}
                                />
                            </div>
                            : ""
                    }
                </div>
                <Popup />
            </Fragment>
            {
                <PopupConfirm
                    modalId="popup-confirm-single-delete"
                    triggerButtonId="popup-click-confirm-single-delete"
                    message={
                        singleDeleteConfirm?.isPair
                            ? intl.formatMessage({
                                  id: "deleteDiamondMatchedPairWarning",
                                  defaultMessage:
                                      "Matched pair: your pair product will be unlinked. Delete this item?",
                              })
                            : intl.formatMessage({
                                  id: "deleteDiamondConfirmSingle",
                                  defaultMessage:
                                      "Are you sure you want to delete this product?",
                              })
                    }
                    title={intl.formatMessage({
                        id: "Confirmation",
                        defaultMessage: "Confirmation",
                    })}
                    handleResForm={handleSingleDeleteResForm}
                />
            }
            {
                <PopupConfirm
                    modalId="popup-confirm-bulk-delete"
                    triggerButtonId="popup-click-confirm-bulk-delete"
                    message={
                        bulkDeleteConfirm?.isPair
                            ? intl.formatMessage({
                                  id: "deleteDiamondMatchedPairWarning",
                                  defaultMessage:
                                      "Matched pair: your pair product will be unlinked. Delete this item?",
                              })
                            : intl.formatMessage({
                                  id: "deleteDiamondConfirmSelected",
                                  defaultMessage:
                                      "Are you sure you want to delete the selected items?",
                              })
                    }
                    title={intl.formatMessage({
                        id: "Confirmation",
                        defaultMessage: "Confirmation",
                    })}
                    handleResForm={handleBulkDeleteResForm}
                />
            }
            {
                <PopupConfirm
                    modalId="popup-confirm-seller-action"
                    triggerButtonId="popup-click-confirm-seller-action"
                    message={sellerActionConfirmMessage()}
                    title={intl.formatMessage({
                        id: 'Confirmation',
                        defaultMessage: 'Confirmation',
                    })}
                    handleResForm={handleSellerActionResForm}
                />
            }
            {
                <PopupConfirm
                    message={intl.formatMessage({ id: "deleteAllProducts" })}
                    title={intl.formatMessage({ id: "Confirmation" })}
                    handleResForm={handleResForm}
                />
            }
        </Fragment>
    )
}

export default WhiteDimonds